import { createContext, useContext } from 'react';

/** Everything the EmployeeGeneralDataForm sections read: field keys, field states, watched values and handlers. */
const EmployeeGeneralDataFormContext = createContext(null);

export const useEmployeeGeneralDataForm = () =>
  useContext(EmployeeGeneralDataFormContext);

export default EmployeeGeneralDataFormContext;
